module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAS1BMVEUAAACpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkOpbkMbtDJnAAAAGHRSTlMA871ScXowEDzi3e7HtFsX645DIKBiSs24Q4+JAAAAtElEQVQ4y+3S2w6DIAyA4aIrouD5sL7/k45qYmckxfvtv6gx+VI1CLdc7VfINlNsyrKOGWZZyez1Z7/FJvfN7JRWC9EiPxIShSqhVoq1YPnSwXjoe0jc6Hhu3XGTYFVDnOdR056FtJNE3V2tK3GakvrhVA6U+kbfJc/NKflek1AO7dUhztcXwfI46g2U5oFPzUQWNNZSDHgUGgsRmH1bq247mS+U/MkyMaNHwfuJGqAPJlvjPt4FIg6Ltbu0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sb2.png
// module id = Ebap
// module chunks = 1